import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getTimezonesService } from '../../services/timezone';
import * as type from '../ActionTypes';
import { getContractByJobIdService, getContractService } from '../../services/contract';
import { getJobByIdService } from '../../services/jobs';
import { clientProfileDataByIdService } from '../../services/clientProfileData';
import { getCoderByIdService } from '../../services/profile/coder.service';

function* getContractForClientData(payload: any): any {
  try {
    const contract = yield call(getContractService, payload.params);
    const contractData = contract.data.results;

    const jobPostData = yield all(
      contractData.map((o: any) => call(getJobByIdService, o.job_post))
    );
    const clientData = yield all(
      contractData.map((o: any) => call(clientProfileDataByIdService, o.client_id))
    );

    if (
      contract.status === 200 &&
      jobPostData.length > 0 &&
      jobPostData[0].status === 200 &&
      clientData.length > 0 &&
      clientData[0].status === 200
    ) {
      const jobPostDataArr = jobPostData.map((o: any) => o.data);
      const clientDataArr = clientData.map((o: any) => o.data);

      const jobPost_clientData = jobPostDataArr.map((o: any, index: any) => ({
        ...o,
        job_contract: contractData[index].id,
        clientData:
          clientDataArr.filter((cd: any) => cd.id == o.user).length > 0
            ? clientDataArr.filter((cd: any) => cd.id == o.user)[0]
            : {}
      }));

      yield put({
        type: type.GET_CONTRACT_SUCCESS,
        payload: { ...contract.data, results: jobPost_clientData }
      });
    } else {
      yield put({ type: type.GET_CONTRACT_FAILURE, message: 'Oops, something went wrong!' });
    }
  } catch (e: any) {
    yield put({ type: type.GET_CONTRACT_FAILURE, message: e.message });
    console.warn(e.message);
  }
}
function* getContract({ payload }: any): any {
  try {
    const contract = yield call(getContractService, payload);
    const contractData = contract.data.results;

    if (contract.status === 200) {
      yield put({
        type: type.GET_CONTRACT_SUCCESS,
        payload: contractData
      });
    } else {
      yield put({ type: type.GET_CONTRACT_SUCCESS, payload: [] });
    }
  } catch (e: any) {
    yield put({ type: type.GET_CONTRACT_FAILURE, message: e.message });
    console.warn(e.message);
  }
}

function* getContractForClientDashboard(action: any): any {
  try {
    const contract = yield call(getContractService, action.params);
    const contractData = contract.data.results;

    const jobPostData = yield all(
      contractData.map((o: any) => call(getJobByIdService, o.job_post))
    );
    if (contract.status === 200 && jobPostData.length > 0 && jobPostData[0].status === 200) {
      const jobPostDataArr = jobPostData.map((o: any) => o.data);

      const jobPost_clientData = jobPostDataArr.map((o: any) => ({
        ...o,
        contractData: contractData.find((el: any) => el.job_post === o.id)
      }));
      yield put({
        type: type.GET_CONTRACT_SUCCESS,
        payload: {
          results: jobPost_clientData,
          total_pages: contract.data.total_pages,
          count: contract.data.count
        }
      });
    } else {
      yield put({ type: type.GET_CONTRACT_FAILURE, message: 'Oops, something went wrong!' });
    }
  } catch (e: any) {
    yield put({ type: type.GET_CONTRACT_FAILURE, message: e.message });
    console.warn(e.message);
  }
}

function* getContractByJobId(action: any): any {
  try {
    const contractResponse = yield call(getContractByJobIdService, action.params);
    const contractData = yield all(
      contractResponse.data.results.map((o: any) => call(getCoderByIdService, o.coder_id))
    );
    const coders_with_contract = contractData.map((o: any) => o.data);
    const contractResults = contractResponse.data.results.map((contract: any) => ({
      ...contract,
      coderData: coders_with_contract.find((cd: any) => cd.id === contract.coder_id)
    }));
    yield put({
      type: type.GET_CONTRACT_BY_JOB_ID_SUCCESS,
      payload: contractResults
    });
  } catch (e: any) {
    yield put({ type: type.GET_CONTRACT_BY_JOB_ID_FAILURE, message: e.message });
    console.warn(e.message);
  }
}

function* contractSaga() {
  yield takeEvery(type.GET_CONTRACT_REQUEST_FOR_CLIENT_DATA, getContractForClientData);
  yield takeEvery(type.GET_CONTRACT_REQUEST, getContract);
  yield takeEvery(type.GET_CONTRACT_REQUEST_FOR_CLIENT_DASH, getContractForClientDashboard);
  yield takeEvery(type.GET_CONTRACT_BY_JOB_ID_REQUEST, getContractByJobId);
}

export default contractSaga;
